import { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import { ERROR_MESSAGES } from '../constants';

/**
 * Custom hook to get user's geolocation
 * @returns {Object} - Geolocation state and function
 */
export const useGeolocation = () => {
  const [coordinates, setCoordinates] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getLocation = useCallback(() => {
    if (!navigator.geolocation) {
      const errorMsg = ERROR_MESSAGES.GEOLOCATION_UNAVAILABLE;
      setError(errorMsg);
      toast.error(errorMsg);
      return;
    }

    setLoading(true);
    setError(null);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setCoordinates({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
        setLoading(false);
      },
      (error) => {
        let errorMsg = ERROR_MESSAGES.GEOLOCATION_DENIED;
        
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMsg = ERROR_MESSAGES.GEOLOCATION_DENIED;
            break;
          case error.POSITION_UNAVAILABLE:
            errorMsg = ERROR_MESSAGES.GEOLOCATION_UNAVAILABLE;
            break;
          case error.TIMEOUT:
            errorMsg = ERROR_MESSAGES.GEOLOCATION_TIMEOUT;
            break;
          default:
            errorMsg = ERROR_MESSAGES.GEOLOCATION_DENIED;
        }
        
        setError(errorMsg);
        toast.error(errorMsg);
        setLoading(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  }, []);

  return {
    coordinates,
    loading,
    error,
    getLocation,
  };
};

export default useGeolocation;
